import http from '@/utils/http'
import utils from '@/utils/util';
function addTokenAndKeyParams(options = {}) {
  let base = {}
  if (utils.getQueryString('appkey',location.search.slice(1))) {
    base = {
      oauth_token: utils.getQueryString('oauth_token',location.search.slice(1)),
      appkey: utils.getQueryString('appkey',location.search.slice(1)),
      appSource: 'qxtx'
    }
  } else {
    let token = utils.getQueryString('token');
    base = {
      oauth_token: process.env.NODE_ENV === 'development' ? '80576e15eed87dc6f3b514bb7af41b79' : (token || utils.getStorage('localStorage', 'oauth_token')),
      appkey: 'kTjxJFdkA1POnvgg',
      appSource: 'qxtx'
    }
    if (token) {
      utils.setStorage('localStorage','oauth_token',token)
    }
  }
  return Object.assign(base, options)
}
// https://qiaoxingtx.com
export const getNoticeDetail = (data) => {
  return http({
    url: '/qxtx/app/qxtxNotice/findNoticeDetail',
    method: 'post',
    data: addTokenAndKeyParams(data),
    isFromQxtx: true,
    backUrl: encodeURIComponent(location.pathname + location.hash)
  })
}
export const getNoticeArticle = (data) => {
  return http({
    url: '/qxtx/app/qxtxNotice/noticeDetail/notLogin',
    method: 'post',
    data: addTokenAndKeyParams(data),
    isFromQxtx: true,
    backUrl: encodeURIComponent(location.pathname + location.hash)
  })
}
